module.exports = __webpack_public_path__ + "7b769a9047d61af7d9cdb8354ee2174e.png";